import styled from "styled-components";
import {COLORS} from "../../../shared/consts";

export const CardWrapper = styled.div`
    display: flex;
    gap: 32px;
    border-radius: 16px;

    @media (max-width: 768px) {
        gap: 12px;
    }
`;

export const ImageWrapper = styled.div`
    border-radius: 16px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 240px;
    max-height: 240px;

    @media (max-width: 768px) {
        max-width: 148px;
        max-height: 148px;
        width: 100%;
    }
`;

export const DeviceImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 32px 0px;

    @media (max-width: 768px) {
        gap: 8px;
        padding: 0;
    }
`;

export const Title = styled.h3`
    font-size: 20px;
    font-weight: 700;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

export const Description = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: ${COLORS.FG.SOFT};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-width: 360px;
    max-height: 40px;
`;
